import { Link } from "react-router-dom";

export function BrandLogo({ className = "", onClick }) {
  return (
    <Link to="/" onClick={onClick} className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand text-white font-heading font-extrabold text-lg shadow-sm">
        ID
      </span>
      <span className="font-heading text-lg font-extrabold tracking-tight text-ink">
        IDEbisnis<span className="text-brand-accent"> AI</span>
      </span>
    </Link>
  );
}

// The 7-step future journey, shared across landing + dashboard.
export const JOURNEY_STEPS = [
  { key: "profil", title: "Profil Bisnis", short: "PROFIL", desc: "Ceritakan modal, kemampuan, waktu, dan kondisi Anda." },
  { key: "ide", title: "5 Ide Bisnis", short: "5 IDE", desc: "Dapatkan ide yang sesuai dengan situasi Anda." },
  { key: "pilih", title: "Pilih 2 Ide", short: "PILIH 2", desc: "Persempit menjadi dua kandidat terbaik." },
  { key: "validasi", title: "Validasi", short: "VALIDASI", desc: "Bandingkan fit, potensi, risiko, dan eksekusi." },
  { key: "winner", title: "Business Winner", short: "WINNER", desc: "Temukan satu pilihan paling layak diuji." },
  { key: "blueprint", title: "Business Blueprint", short: "BLUEPRINT", desc: "Ubah pilihan menjadi rencana yang jelas." },
  { key: "launch", title: "Launch Plan", short: "LAUNCH", desc: "Rencana 7 hari untuk mulai menguji pasar." },
];
